import CustomButton from '@/components/atoms/CustomButton';
import { extra, text } from '@/theme/colors/palettes';
import { Text, VStack } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import React, { CSSProperties } from 'react';

interface Props {
  buttonColor?: 'primary' | 'secondary';
  containerStyle?: CSSProperties;
}

const RetakeScreenerReminderWithButton = ({ buttonColor = 'primary', containerStyle }: Props) => {
  const navigate = useNavigate();

  return (
    <VStack gap={4} style={containerStyle}>
      <CustomButton
        label={'Retake Screener'}
        onClick={() => navigate({ to: '/screener/$screenerId', params: { screenerId: 'wholeness-screener' } })}
        labelColor={extra.white}
        backgroundColor={`${buttonColor}.500`}
        hoverBackgroundColor={`${buttonColor}.600`}
        borderHoverWidth="3px"
        width={'90%'}
      />
      <Text variant="urbanistSmall" style={{ color: text.mediumGray, fontWeight: 500, textAlign: 'center' }}>
        Checking in every 30 days to measure progress and highlight your priorities can help you continuously focus on
        what matters to you.
      </Text>
    </VStack>
  );
};

export default RetakeScreenerReminderWithButton;
